import styled from 'styled-components';

export const BreadcrumbContainer = styled.div`
  width: 100%;
  padding: 16px 24px 8px 24px;
  background: #ffffff;
`;

export const CustomBreadcrumbWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderContainer = styled.div`
  padding-block: 20px;
  background: #ffffff;
  display: flex;
  align-items: flex-end;
  gap: 24px;
`;

export const HeaderLeft = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HeaderRight = styled.div`
  flex: 0 0 20%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const TitleContainer = styled.div`
  margin: 0;
`;

export const SubtitleContainer = styled.div`
  margin: 0;
`;

export const TabsContainer = styled.div`
  padding: 0 24px;
  background: #ffffff;
`;
